import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  className?: string
}

function ArrowLeft({ className }: Props) {
  return (
    <IconBase name="arrow-left" w={24} className={className}>
      <line x1="19" y1="11.5" x2="5" y2="11.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.5 19L4 11.5L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </IconBase>
  )
}

export default ArrowLeft
